var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEducation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 86,
    viewBox: "0 0 80 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 45.1201C0 67.2101 17.91 85.1201 40 85.1201C62.09 85.1201 80 67.2101 80 45.1201C80 23.0301 62.09 5.12012 40 5.12012C17.91 5.12012 0 23.0301 0 45.1201Z",
    fill: "#E0E9FD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 73.8397C20.5 74.8897 29.26 75.7497 40.06 75.7497C50.86 75.7497 59.62 74.8897 59.62 73.8397C59.62 72.7897 50.86 71.9297 40.06 71.9297C29.26 71.9297 20.5 72.7897 20.5 73.8397Z",
    fill: "#2B6BF3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3599 72.8403H18.4499C15.5299 72.8403 13.1699 70.4703 13.1699 67.5603C13.1699 64.6503 15.5399 62.2803 18.4499 62.2803H44.3599V72.8503V72.8403Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3599 72.8403H18.4499C15.5299 72.8403 13.1699 70.4703 13.1699 67.5603C13.1699 64.6503 15.5399 62.2803 18.4499 62.2803H44.3599V72.8503V72.8403Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9102 72.8395H22.4402C19.5202 72.8395 17.1602 70.4695 17.1602 67.5595C17.1602 64.6495 19.5302 62.2695 22.4402 62.2695H25.9102C22.9902 62.2695 20.6302 64.6395 20.6302 67.5595C20.6302 70.4795 23.0002 72.8395 25.9102 72.8395Z",
    fill: "#2B6BF3",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.07 64.6195C36.45 64.5895 35.11 65.8795 35.08 67.4995C35.05 69.1195 36.34 70.4595 37.96 70.4895C38 70.4895 38.03 70.4895 38.07 70.4895H63.98C64.63 70.4895 65.15 71.0095 65.15 71.6595C65.15 72.3095 64.63 72.8295 63.98 72.8295H38.07C35.15 72.8295 32.79 70.4595 32.79 67.5495C32.79 64.6395 35.16 62.2695 38.07 62.2695H63.98C64.63 62.2895 65.14 62.8295 65.12 63.4795C65.1 64.0995 64.6 64.5995 63.98 64.6195H38.07Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38.07 64.6195C36.45 64.5895 35.11 65.8795 35.08 67.4995C35.05 69.1195 36.34 70.4595 37.96 70.4895C38 70.4895 38.03 70.4895 38.07 70.4895H63.98C64.63 70.4895 65.15 71.0095 65.15 71.6595C65.15 72.3095 64.63 72.8295 63.98 72.8295H38.07C35.15 72.8295 32.79 70.4595 32.79 67.5495C32.79 64.6395 35.16 62.2695 38.07 62.2695H63.98C64.63 62.2895 65.14 62.8295 65.12 63.4795C65.1 64.0995 64.6 64.5995 63.98 64.6195H38.07Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9796 70.4896V64.6197H38.0696C36.4496 64.5897 35.1096 65.8797 35.0796 67.4997C35.0496 69.1197 36.3396 70.4596 37.9596 70.4896C37.9996 70.4896 38.0296 70.4896 38.0696 70.4896H63.9796Z",
    fill: "#2B6BF3",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7695 62.0895H21.8595C18.9395 62.1295 16.5395 59.7995 16.4995 56.8795C16.4595 53.9595 18.7895 51.5595 21.7095 51.5195C21.7595 51.5195 21.8095 51.5195 21.8595 51.5195H47.7695V62.0895Z",
    fill: "#2B6BF3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7695 62.0895H21.8595C18.9395 62.1295 16.5395 59.7995 16.4995 56.8795C16.4595 53.9595 18.7895 51.5595 21.7095 51.5195C21.7595 51.5195 21.8095 51.5195 21.8595 51.5195H47.7695V62.0895Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6398 53.8698C39.0198 53.8398 37.6798 55.1298 37.6498 56.7498C37.6198 58.3698 38.9098 59.7098 40.5298 59.7398C40.5698 59.7398 40.5998 59.7398 40.6398 59.7398H66.5498C67.1998 59.7398 67.7198 60.2698 67.7198 60.9098C67.7198 61.5598 67.1898 62.0798 66.5498 62.0798H40.6398C37.7198 62.1198 35.3198 59.7898 35.2798 56.8698C35.2398 53.9498 37.5698 51.5498 40.4898 51.5098C40.5398 51.5098 40.5898 51.5098 40.6398 51.5098H66.5498C67.1998 51.5098 67.7198 52.0398 67.7198 52.6798C67.7198 53.3298 67.1898 53.8498 66.5498 53.8498H40.6398V53.8698Z",
    fill: "#2B6BF3"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6398 53.8698C39.0198 53.8398 37.6798 55.1298 37.6498 56.7498C37.6198 58.3698 38.9098 59.7098 40.5298 59.7398C40.5698 59.7398 40.5998 59.7398 40.6398 59.7398H66.5498C67.1998 59.7398 67.7198 60.2698 67.7198 60.9098C67.7198 61.5598 67.1898 62.0798 66.5498 62.0798H40.6398C37.7198 62.1198 35.3198 59.7898 35.2798 56.8698C35.2398 53.9498 37.5698 51.5498 40.4898 51.5098C40.5398 51.5098 40.5898 51.5098 40.6398 51.5098H66.5498C67.1998 51.5098 67.7198 52.0398 67.7198 52.6798C67.7198 53.3298 67.1898 53.8498 66.5498 53.8498H40.6398V53.8698Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5499 59.7397V53.8697H40.6399C39.0199 53.8397 37.6799 55.1297 37.6499 56.7497C37.6199 58.3697 38.9099 59.7097 40.5299 59.7397C40.5699 59.7397 40.5999 59.7397 40.6399 59.7397H66.5499Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3096 62.0903H25.8396C22.9196 62.0903 20.5596 59.7203 20.5596 56.8103C20.5596 53.9003 22.9296 51.5303 25.8396 51.5303H29.3096C26.3896 51.5303 24.0296 53.9003 24.0296 56.8103C24.0296 59.7203 26.3996 62.0903 29.3096 62.0903Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9998 40.3999C57.9998 40.3999 56.8098 44.6799 53.8498 46.6199C53.3098 46.9699 52.5998 46.8199 52.2498 46.2799C52.1598 46.1399 52.0998 45.9799 52.0698 45.8099C51.8698 43.4999 52.3798 41.1799 53.5398 39.1699L57.9998 40.4099V40.3999Z",
    fill: "#2B6BF3",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1699 40.3999C25.1699 40.3999 26.3599 44.6799 29.3199 46.6199C29.8599 46.9699 30.5699 46.8199 30.9199 46.2799C31.0099 46.1399 31.0699 45.9799 31.0999 45.8099C31.2999 43.4999 30.7899 41.1799 29.6299 39.1699L25.1699 40.4099V40.3999Z",
    fill: "#2B6BF3",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M41.59 8.59961C49.9 8.59961 56.64 15.3396 56.64 23.6496C56.64 31.9596 56.64 49.1196 41.59 49.1196C26.54 49.1196 27.03 31.6596 26.54 23.6496C26.03 15.3496 33.28 8.59961 41.59 8.59961Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5403 23.6504C26.6603 25.6404 28.3703 27.1704 30.3603 27.0504C30.4603 27.0504 30.5603 27.0304 30.6603 27.0204C36.9303 26.1004 41.5703 20.7304 41.5803 14.3904C41.5803 20.8404 46.4003 26.2803 52.8103 27.0504C54.6803 27.2703 56.3803 25.9304 56.6103 24.0604C56.6303 23.9304 56.6303 23.7904 56.6303 23.6604C56.6303 15.3504 49.8903 8.61035 41.5803 8.61035C33.2703 8.61035 26.0303 15.3604 26.5303 23.6604L26.5403 23.6504Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1902 32.62C44.1902 34.06 43.0202 35.22 41.5902 35.22C40.1602 35.22 38.9902 34.05 38.9902 32.62C38.9902 32.32 39.0402 32.03 39.1502 31.75C39.6202 33.1 41.1002 33.82 42.4502 33.35C43.2002 33.09 43.7902 32.5 44.0502 31.75C44.1502 32.03 44.2102 32.32 44.2002 32.62H44.1902Z",
    fill: "#2B6BF3"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2997 30.6596C30.8597 32.0296 31.5997 33.4996 32.9697 33.9396C34.3397 34.3796 35.8097 33.6396 36.2497 32.2696C36.3397 31.9896 36.3797 31.6896 36.3697 31.3996C35.4997 32.5396 33.8697 32.7596 32.7297 31.8896C32.0997 31.4096 31.7297 30.6796 31.7097 29.8896C31.5197 30.1196 31.3797 30.3896 31.2897 30.6696L31.2997 30.6596Z",
    fill: "#2B6BF3"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8801 30.6596C52.3201 32.0296 51.5701 33.4996 50.2101 33.9396C48.8501 34.3796 47.3701 33.6296 46.9301 32.2696C46.8401 31.9896 46.8001 31.6896 46.8101 31.3996C47.6801 32.5396 49.3101 32.7596 50.4501 31.8896C51.0801 31.4096 51.4501 30.6796 51.4701 29.8896C51.6601 30.1196 51.8001 30.3896 51.8901 30.6696L51.8801 30.6596Z",
    fill: "#2B6BF3"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3301 0.5H50.8501V8.6H32.3301V0.5Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3301 0.5H50.8501V8.6H32.3301V0.5Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6904 0.5H55.4704",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5302 8.60039C53.1602 6.28039 55.4802 7.44039 55.4802 7.44039L41.5902 20.1704L27.7002 7.44039C27.7002 7.44039 30.0102 6.28039 34.6502 8.60039H48.5402H48.5302Z",
    fill: "#2B6BF3",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8496 16.7103C28.8496 19.2703 30.9196 21.3403 33.4796 21.3403C36.0396 21.3403 38.1096 19.2703 38.1096 16.7103C38.1096 14.1503 36.0396 12.0703 33.4796 12.0703C30.9196 12.0703 28.8496 14.1403 28.8496 16.7003V16.7103Z",
    fill: "#2B6BF3",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0596 16.7101C45.0596 19.2701 47.1296 21.3401 49.6896 21.3401C52.2496 21.3401 54.3196 19.2701 54.3196 16.7101C54.3196 14.1501 52.2496 12.0801 49.6896 12.0801C47.1296 12.0801 45.0596 14.1501 45.0596 16.7101Z",
    fill: "#2B6BF3",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3301 17.2898C32.3301 18.2498 33.1101 19.0298 34.0701 19.0298C35.0301 19.0298 35.8101 18.2498 35.8101 17.2898C35.8101 16.3298 35.0301 15.5498 34.0701 15.5498C33.1101 15.5498 32.3301 16.3298 32.3301 17.2898Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3701 17.2898C47.3701 18.2498 48.1501 19.0298 49.1101 19.0298C50.0701 19.0298 50.8501 18.2498 50.8501 17.2898C50.8501 16.3298 50.0701 15.5498 49.1101 15.5498C48.1501 15.5498 47.3701 16.3298 47.3701 17.2898Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1096 17.8595C38.0796 15.9395 39.6096 14.3595 41.5196 14.3295C43.4396 14.2995 45.0196 15.8295 45.0496 17.7395C45.0496 17.7795 45.0496 17.8195 45.0496 17.8595L42.5696 21.9895C42.2396 22.5395 41.5296 22.7195 40.9796 22.3895C40.8196 22.2895 40.6796 22.1595 40.5796 21.9895L38.0996 17.8595H38.1096Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0098 16.7098C30.0098 17.3498 30.5298 17.8698 31.1698 17.8698C31.8098 17.8698 32.3298 17.3498 32.3298 16.7098C32.3298 16.0698 31.8098 15.5498 31.1698 15.5498C30.5298 15.5498 30.0098 16.0698 30.0098 16.7098Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2197 16.7098C46.2197 17.3498 46.7397 17.8698 47.3797 17.8698C48.0197 17.8698 48.5397 17.3498 48.5397 16.7098C48.5397 16.0698 48.0197 15.5498 47.3797 15.5498C46.7397 15.5498 46.2197 16.0698 46.2197 16.7098Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M26.54 24.8096C26.54 24.8096 30.01 29.4396 28.85 39.8596C28.85 41.3396 27.65 42.5396 26.17 42.5396C25.02 42.5396 24 41.8096 23.63 40.7296C22 35.9896 21.23 29.4496 26.54 24.8096Z",
    fill: "#2B6BF3",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6395 24.8096C56.6395 24.8096 53.1695 29.4396 54.3195 39.8596C54.3195 41.3396 55.5195 42.5396 56.9995 42.5396C58.1495 42.5396 59.1695 41.8096 59.5395 40.7296C61.1695 35.9896 61.9395 29.4496 56.6395 24.8096Z",
    fill: "#2B6BF3",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3499 50.8598C50.3699 51.8198 49.6099 52.6198 48.6599 52.6398C47.7099 52.6598 46.8999 51.8998 46.8799 50.9498C46.8799 50.9198 46.8799 50.8898 46.8799 50.8698V47.3998C46.8999 46.4398 47.6999 45.6798 48.6599 45.7098C49.5899 45.7298 50.3299 46.4798 50.3499 47.3998V50.8698V50.8598Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3499 50.8598C50.3699 51.8198 49.6099 52.6198 48.6599 52.6398C47.7099 52.6598 46.8999 51.8998 46.8799 50.9498C46.8799 50.9198 46.8799 50.8898 46.8799 50.8698V47.3998C46.8999 46.4398 47.6999 45.6798 48.6599 45.7098C49.5899 45.7298 50.3299 46.4798 50.3499 47.3998V50.8698V50.8598Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8198 50.8604C53.8198 51.8204 53.0398 52.6004 52.0798 52.6004C51.1198 52.6004 50.3398 51.8204 50.3398 50.8604V47.3904C50.3398 46.4304 51.1198 45.6504 52.0798 45.6504C53.0398 45.6504 53.8198 46.4304 53.8198 47.3904V50.8604Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8198 50.8604C53.8198 51.8204 53.0398 52.6004 52.0798 52.6004C51.1198 52.6004 50.3398 51.8204 50.3398 50.8604V47.3904C50.3398 46.4304 51.1198 45.6504 52.0798 45.6504C53.0398 45.6504 53.8198 46.4304 53.8198 47.3904V50.8604Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9798 50.8598C32.9998 51.8198 32.2398 52.6198 31.2898 52.6398C30.3398 52.6598 29.5298 51.8998 29.5098 50.9498C29.5098 50.9198 29.5098 50.8898 29.5098 50.8698V47.3998C29.5298 46.4398 30.3298 45.6798 31.2898 45.7098C32.2198 45.7298 32.9598 46.4798 32.9798 47.3998V50.8698V50.8598Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9798 50.8598C32.9998 51.8198 32.2398 52.6198 31.2898 52.6398C30.3398 52.6598 29.5298 51.8998 29.5098 50.9498C29.5098 50.9198 29.5098 50.8898 29.5098 50.8698V47.3998C29.5298 46.4398 30.3298 45.6798 31.2898 45.7098C32.2198 45.7298 32.9598 46.4798 32.9798 47.3998V50.8698V50.8598Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4505 50.8598C36.4705 51.8198 35.7105 52.6198 34.7605 52.6398C33.8105 52.6598 33.0005 51.8998 32.9805 50.9498C32.9805 50.9198 32.9805 50.8898 32.9805 50.8698V47.3998C33.0005 46.4398 33.8005 45.6798 34.7605 45.7098C35.6905 45.7298 36.4305 46.4798 36.4505 47.3998V50.8698V50.8598Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4505 50.8598C36.4705 51.8198 35.7105 52.6198 34.7605 52.6398C33.8105 52.6598 33.0005 51.8998 32.9805 50.9498C32.9805 50.9198 32.9805 50.8898 32.9805 50.8698V47.3998C33.0005 46.4398 33.8005 45.6798 34.7605 45.7098C35.6905 45.7298 36.4305 46.4798 36.4505 47.3998V50.8698V50.8598Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3496 0.5V3.97",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1904 6.28973C27.1904 7.56973 27.7104 8.60973 28.3504 8.60973C28.9904 8.60973 29.5104 7.56973 29.5104 6.28973C29.5104 5.00973 28.9904 3.96973 28.3504 3.96973C27.7104 3.96973 27.1904 5.00973 27.1904 6.28973Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducation);
export default __webpack_public_path__ + "static/media/education.f9092c6ec87b3f7ad7e0113a5b72827c.svg";
export { ForwardRef as ReactComponent };